import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import brands from './brands.json';

const root = ReactDOM.createRoot(document.getElementById('root'));
const brandName = process.env.REACT_APP_BRAND; // Make sure to set this in your .env file

setBrandColors(brandName);

function setBrandColors(brandName) {
  const root = document.documentElement;
  const brand = brands[brandName];
  root.style.setProperty('--primary-color', brand.primaryColor);
  root.style.setProperty('--secondary-color', brand.secondaryColor);
  root.style.setProperty('--banner-logo', `url("/images/${brand.banner_logo}")`)
  
}



root.render(
     <BrowserRouter> {/* Wrap App component with BrowserRouter */}
    <App />
    </BrowserRouter>
);